module.exports = __webpack_public_path__ + "img/3.298b8248.png";